import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {UserLevel} from '@netx/core-user-next/constants';
import {
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next/enablers';

export const canViewShareLinks = () => {
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS)
}
